import { Pipe, PipeTransform } from '@angular/core';
import format from 'date-fns/format';
import de from 'date-fns/locale/de';
import es from 'date-fns/locale/es';
import pt from 'date-fns/locale/pt';
import it from 'date-fns/locale/it';
import { languages } from '../../../constants/language.constants';

export const langLocales: { [language in Exclude<languages, languages.en>]: any } = {
  de: de,
  es: es,
  pt: pt,
  it: it
};

@Pipe({
  name: 'formatDate',
  standalone: false
})
export class FormatDatePipe implements PipeTransform {
  transform(value: Date, formatString: string, lang: languages): any {
    let formattedDate;

    if (lang !== languages.en) {
      formattedDate = format(value, formatString, { locale: langLocales[lang] });
    } else {
      formattedDate = format(value, formatString);
    }

    return formattedDate;
  }
}
